export const STATES_AND_UTS = [
    // 🟩 States (28)
    $localize`:@@states.andhra_pradesh:Andhra Pradesh`,
    $localize`:@@states.arunachal_pradesh:Arunachal Pradesh`,
    $localize`:@@states.assam:Assam`,
    $localize`:@@states.bihar:Bihar`,
    $localize`:@@states.chhattisgarh:Chhattisgarh`,
    $localize`:@@states.goa:Goa`,
    $localize`:@@states.gujarat:Gujarat`,
    $localize`:@@states.haryana:Haryana`,
    $localize`:@@states.himachal_pradesh:Himachal Pradesh`,
    $localize`:@@states.jharkhand:Jharkhand`,
    $localize`:@@states.karnataka:Karnataka`,
    $localize`:@@states.kerala:Kerala`,
    $localize`:@@states.madhya_pradesh:Madhya Pradesh`,
    $localize`:@@states.maharashtra:Maharashtra`,
    $localize`:@@states.manipur:Manipur`,
    $localize`:@@states.meghalaya:Meghalaya`,
    $localize`:@@states.mizoram:Mizoram`,
    $localize`:@@states.nagaland:Nagaland`,
    $localize`:@@states.odisha:Odisha`,
    $localize`:@@states.punjab:Punjab`,
    $localize`:@@states.rajasthan:Rajasthan`,
    $localize`:@@states.sikkim:Sikkim`,
    $localize`:@@states.tamil_nadu:Tamil Nadu`,
    $localize`:@@states.telangana:Telangana`,
    $localize`:@@states.tripura:Tripura`,
    $localize`:@@states.uttarakhand:Uttarakhand`,
    $localize`:@@states.uttar_pradesh:Uttar Pradesh`,
    $localize`:@@states.west_bengal:West Bengal`,

    // 🟦 Union Territories (8)
    $localize`:@@uts.andaman_and_nicobar:Andaman and Nicobar Islands`,
    $localize`:@@uts.chandigarh:Chandigarh`,
    $localize`:@@uts.dadra_and_nagar_haveli_and_daman_and_diu:Dadra and Nagar Haveli and Daman and Diu`,
    $localize`:@@uts.delhi:Delhi`,
    $localize`:@@uts.jammu_and_kashmir:Jammu and Kashmir`,
    $localize`:@@uts.ladakh:Ladakh`,
    $localize`:@@uts.lakshadweep:Lakshadweep`,
    $localize`:@@uts.puducherry:Puducherry`,
];
